.badge {
  display: inline-flex;
  width: fit-content;
  max-width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.3rem;
  padding: 0.7rem 1rem;
  border: 1px solid var(--ma-border-strong);
  border-inline-start: 3px solid var(--ma-accent);
  border-radius: 2px;
  background: linear-gradient(120deg, var(--ma-raised), var(--ma-surface));
  color: var(--ma-fg);
  text-align: start;
}

.badge > span {
  color: var(--ma-muted);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.13em;
  line-height: 1.3;
}

.badge > strong {
  color: var(--ma-fg);
  font-size: 0.875rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  line-height: 1.35;
}
